import { Page } from '../skeleton/Page';
import { PageTitle } from '../page-title';
import { FC, useContext } from 'react';
import { Grid } from '@mui/material';
import { UserContext } from '../../context';
import { useFlags, useAllowedNavRoutes } from '../../hooks';

interface IPortalLayout {
  children: any;
  title: string;
}

export const PortalLayout: FC<IPortalLayout> = ({ children, title }) => {
  const userContext = useContext(UserContext);
  const { user } = userContext;
  const featureFlags = useFlags();
  const { availableLinks } = useAllowedNavRoutes(featureFlags, user);
  return (
    <Page title={title} showSideBar={false}>
      <PageTitle title={title} />
      <Grid spacing={2} container alignItems="center" mb={0.5}>
        {children({ userContext, featureFlags, availableLinks })}
      </Grid>
    </Page>
  );
};
